import React from "react";
import styled from "styled-components";
import { TextView } from "@components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background-color: #ffffff;
  border-radius: 5px;
  height: 25vh;
`;

const StyledImage = styled.img`
  margintop: 12px;
  width: 70%;
  borderradius: 5px;
`;

function Preview2({ businessBoxData }) {
  return (
    <Container>
      {businessBoxData?.advert_image && (
        <StyledImage src={businessBoxData?.advert_image} alt="featureImg" />
      )}

      <TextView
        variant="text"
        style={{
          fontSize: "12px",
          fontFamily: "DM Sans",
          color: "#123051",
          whiteSpace: "pre-wrap",
          overflowWrap: "break-word",
          textAlign: "center",
        }}
      >
        {businessBoxData?.description &&
        businessBoxData.description.length > 180
          ? businessBoxData.description.slice(0, 170) + "..."
          : businessBoxData?.description}
      </TextView>
    </Container>
  );
}

export default Preview2;
